import styled from "styled-components";

export const CreatedPageContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
    width: 100%;
    height: calc(100vh - 280px);
    max-height: calc(100vh - 280px);
`;

export const CreatedPageContent = styled.div`
    flex: 1;
    min-width: 0;
    height: 100%;
    padding: 16px;
`;

export const ChatContainer = styled.div`
    flex: 0 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    width: 100%;
`;
